import { render, staticRenderFns } from "./NoticCrowdList.vue?vue&type=template&id=33e57aaf&scoped=true"
import script from "./NoticCrowdList.vue?vue&type=script&lang=js"
export * from "./NoticCrowdList.vue?vue&type=script&lang=js"
import style0 from "./NoticCrowdList.vue?vue&type=style&index=0&id=33e57aaf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e57aaf",
  null
  
)

export default component.exports